export default __webpack_public_path__ + "static/media/project11.4fc7ce17.png";